/** @format */

import { useEffect, useState } from "react";

//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

import { BlockBtn, MenuBtn, UnBLock } from "../../components/global/btns/btns";

//import table data
import { tableColumnMangerActivity } from "../../components/table/col-data";
import { InternalNav } from "../../components/internalNav";
import { PersonalForm } from "../../components/drivers/Personal-info";
import { UserCard } from "../../components/global/user-card";
import Table from "../../components/Table2";
import { ColumnMangerActivity } from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { getOneManager } from "../../services/managers";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Spinner1 } from "../../components/spinners/Spinner1";
import { ManagerInfo } from "../../components/drivers/ManagerInfo";

const ProfileManger = ({ from }) => {
  const [active, setActive] = useState("last-activity");
  const [role, setRole] = useState();
  const { managerProfile, loading } = useSelector((state) => state.managers);
  let { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    getManagerProfile();
  }, []);
  const getManagerProfile = () => {
    dispatch(getOneManager(id));
  };
  useEffect(() => {
    if (from === "general-manger") setRole("مشرف عام");
  }, [from]);
  return (
    <NavbarAndSidebar>
      {loading && <Spinner1 />}
      <HeadTitle title='الملف الشخصي' margin={true} />

      <UserCard
        role={role}
        from={from}
        managerProfile={managerProfile}
        name={managerProfile.name}
        getManagerProfile={getManagerProfile}
      />
      <div className='mb__small' />
      {/* <InternalNav active={active} setActive={setActive} from='manger' /> */}
      <div className='mb__small' />

      {/* {active === "last-activity" && (
        <Table
          data={[]}
          header={ColumnMangerActivity}
          // link="/profile-guarantor/"
          // getSearchValue={getSearchValue}
          // searchValues={searchValues}
          name='mangerActivity'
        />
      )} */}

      {/* {active === "personal-info" && ( */}
      <ManagerInfo managerProfile={managerProfile} />
      {/* )} */}
    </NavbarAndSidebar>
  );
};
export default ProfileManger;
